package com.damda.design_system.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.damda.design_system.ui.viewmodels.FoodCartState
import com.damda.design_system.ui.views.core.ComposeWindowWidthSizeClass
import com.damda.design_system.ui.views.core.DialogMessage
import com.damda.design_system.ui.views.core.ToastMessage
import com.damda.design_system.ui.views.lists.FoodItem
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

sealed class JSScreen {
    data object Home : JSScreen()
    data object FoodCart : JSScreen()
    data class FoodDetail(val foodItem: FoodItem) : JSScreen()
}

@Composable
fun HedgehogRouter(
    windowSize: ComposeWindowWidthSizeClass,
    foodCartState: FoodCartState,
    screen: JSScreen,
    onScreenClick: (JSScreen) -> Unit
) {
    val onEmptyCartEvent by foodCartState.onEmptyCartEvent
    val onAddCartEvent by foodCartState.onAddCartEvent
    val onNotPhoneDialogEvent by foodCartState.onNotPhoneDialogEvent

    when (screen) {
        is JSScreen.Home -> HomeScreen(
            windowSize = windowSize,
            cartCount = foodCartState.cartCount,
            onCardClick = {
                onScreenClick(JSScreen.FoodDetail(it))
            }, onCartClick = {
                onScreenClick(JSScreen.FoodCart)
            })

        is JSScreen.FoodDetail -> {
            FoodDetailScreen(
                windowSize = windowSize,
                foodItem = screen.foodItem,
                onBackArrowClick = {
                    onScreenClick(JSScreen.Home)
                },
                onClickAddCartButton = { foodItem, count ->
                    repeat(count) {
                        foodCartState.addToCart(foodItem)
                    }
                    onScreenClick(JSScreen.Home)
                })
        }

        is JSScreen.FoodCart -> {
            FoodCartScreen(
                windowSize = windowSize,
                cartState = foodCartState
            ) {
                onScreenClick(JSScreen.Home)
            }
        }
    }

    // toast logics
    onEmptyCartEvent.getContentIfNotHandled()?.let {
        if (it) {
            ToastMessage("장바구니에서 음식을 제거했습니다.", onDismiss = {})
        }
    }
    onAddCartEvent.getContentIfNotHandled()?.let {
        if (it) {
            ToastMessage("장바구니에 추가되었습니다.", onDismiss = {})
        }
    }

    onNotPhoneDialogEvent.getContentIfNotHandled()?.let {
        if (it) {
            DialogMessage(
                onClose = { foodCartState.hideNotPhoneDialogEvent() },
                content = {
                    Div (
                        attrs = {
                            style {
                                width(100.percent)
                                height(100.percent)
                                display(DisplayStyle.Flex)
                                justifyContent(JustifyContent.Center)
                                alignItems(AlignItems.Center)
                            }
                        }
                    ){
                        Text("메시지를 보낼 수 없는 환경입니다. 모바일에서 접속 부탁드리겠습니다.")
                    }
                }
            )
        }
    }

}